<template>
    <!-- :class="{mobile: isMobile ,dash: modals.fullscreen, 'aspin-design': aspinDesign}" -->
    <aside v-show="(!isMobile && modals.fullscreen) || (isMobile && modals.hamburgerMenu)"
           :class="{mobile: isMobile}"
           @click="activeSelect = false" >
        <ul>
            <div class="top">
                <div class="head" :class="{mobile: isMobile}">
                    <BaseMonogram />
                    <div class="user-info label__medium">
                        <span class="name">{{ user.fullname }}</span>
                        <span class="email" v-if="!hideEmail">{{ user.email }}</span>
                    </div>
                </div>
                <div class="account-info">
                    <div>
                        <div class="account-balance label__large">{{currencySign(activeAccount.currency)}}{{activeAccount.balance.toFixed(2).toString()}}</div>
                        <div class="user-id body__extrasmall"># {{ user.id }}</div>
                    </div>
                    <BaseButton :buttonText="tokens.fullScreen.deposit" :buttonStyle="'text-tertiary'" @click.native="changePage('deposit')" />
                </div>
                <!-- not found in new design -->
               <!--  <button v-if="user.enable_autotrader && !hideTradingBot" class="fs-normal" @click="openAutoTraderModal()">Autotrader</button> -->
                <!-- <div class="switch" v-if="aspinDesign && whiteAspinTheme && isMobile" :class="{active: lightTheme}" @click="switchTheme">
                    <div class="dark">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 17 26" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.8541 25.5321C14.9465 26.0547 12.9292 26.1218 10.9631 25.7281C8.99706 25.3343 7.13654 24.4907 5.52997 23.2644C3.92339 22.0381 2.6152 20.463 1.70972 18.6649C0.804239 16.8667 0.32652 14.8952 0.314659 12.9075C0.302796 10.9198 0.75712 8.97095 1.6414 7.21636C2.52568 5.46177 3.81545 3.94997 5.40785 2.80153C7.00026 1.65309 8.85124 0.899784 10.8132 0.601678C12.7752 0.303572 14.7938 0.468917 16.7082 1.08453C14.4117 1.6864 12.3558 2.93599 10.783 4.68588C9.67642 5.91662 8.83084 7.3602 8.29457 8.93408C7.7583 10.5079 7.54185 12.1812 7.65761 13.8583C7.77338 15.5353 8.21907 17.1831 8.96922 18.7076C9.71936 20.2321 10.7592 21.6032 12.0294 22.7427C13.419 24.0142 15.0677 24.9674 16.8541 25.5321Z" fill="#fff"/>
                        </svg>
                    </div>

                    <div class="light">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.51448 3.82869C7.21508 3.70277 6.12701 3.27318 5.58662 3.08801C5.15895 2.92709 4.71196 2.82496 4.25757 2.78433C4.07501 2.84359 4.07501 3.76203 4.13343 4.31753C4.19185 4.87304 4.39632 5.5989 4.44014 5.93961C4.6227 6.97656 7.82118 3.97682 7.51448 3.85831V3.82869ZM13.9772 2.91025C13.7946 2.59917 13.1958 1.56222 12.9475 1.07338C12.725 0.677215 12.4415 0.319654 12.1077 0.0142102C11.9252 -0.111705 11.3191 0.628971 11.0781 1.05856C10.8371 1.48815 10.4136 2.23624 10.2967 2.48066C9.74904 3.3991 14.1013 3.22133 13.948 2.91025H13.9772ZM14.2766 5.19894C13.5276 5.00082 12.7576 4.89635 11.9836 4.88785C11.2288 4.89629 10.4781 5.0008 9.74904 5.19894C8.01982 5.74779 6.54164 6.90676 5.58235 8.46584C4.62305 10.0249 4.24611 11.881 4.51981 13.6976C4.79352 15.5143 5.69977 17.1715 7.07435 18.3688C8.44893 19.5662 10.2009 20.2245 12.0128 20.2245C13.8247 20.2245 15.5767 19.5662 16.9513 18.3688C18.3258 17.1715 19.2321 15.5143 19.5058 13.6976C19.7795 11.881 19.4026 10.0249 18.4433 8.46584C17.484 6.90676 16.0058 5.74779 14.2766 5.19894ZM19.4686 6.42105C19.5344 6.05071 19.7096 4.88785 19.8338 4.33975C19.9457 3.89442 19.9655 3.43042 19.8922 2.97691C19.8338 2.79174 18.9283 2.91766 18.3879 3.09542C17.8475 3.27318 17.1757 3.59167 16.9274 3.65092C15.905 4.01386 19.4029 6.70991 19.4613 6.40624L19.4686 6.42105ZM21.5206 12.6649C21.7616 12.4798 22.6744 11.6872 23.0907 11.3169C23.4442 11.0445 23.7502 10.7141 23.9962 10.3392C24.0619 10.1541 23.2659 9.66521 22.7328 9.48004C22.1998 9.29487 21.5206 9.05045 21.2724 8.93194C20.25 8.5616 21.2139 12.9094 21.5133 12.6353L21.5206 12.6649ZM19.0451 18.7903H21.1044C21.574 18.8125 22.0439 18.7498 22.4919 18.6052C22.6744 18.5459 22.3093 17.6275 22.0683 17.1238C21.7755 16.6726 21.5121 16.2025 21.2797 15.7165C20.7393 14.8573 18.7457 18.7755 19.0451 18.7755V18.7903ZM13.3126 21.916C13.5536 22.0937 14.4591 22.8937 14.8827 23.2566C15.2265 23.5598 15.6129 23.8094 16.0292 23.9973C16.2702 24.0565 16.5769 23.1381 16.6937 22.59C16.8105 22.0419 16.8763 21.3012 16.9347 20.9901C17.1172 19.9532 13.0717 21.6715 13.2834 21.916H13.3126ZM6.9741 20.5457C7.03252 20.8494 7.21508 22.0271 7.33192 22.5678C7.36805 23.0153 7.4922 23.451 7.69704 23.8491C7.8796 24.0343 8.66827 23.6047 9.08451 23.2344C9.50075 22.864 10.0557 22.3826 10.2967 22.1974C11.0781 21.5234 6.91568 20.1754 6.9741 20.5457ZM2.93582 15.3388C2.81168 15.5832 2.20558 16.6276 1.9719 17.1164C1.70312 17.5 1.51656 17.9365 1.42421 18.3978C1.42421 18.5829 2.32972 18.7681 2.88471 18.7681H4.44014C5.64504 18.7681 3.04536 15.1536 2.92852 15.3388H2.93582ZM3.17681 8.72455C2.8774 8.85046 1.78934 9.27265 1.24165 9.46522C0.804243 9.60221 0.390397 9.80709 0.0148327 10.0726C-0.102007 10.2577 0.496796 10.991 0.92034 11.2947C1.34388 11.5984 1.89157 12.1539 2.13255 12.339C2.91392 13.0131 3.4543 8.63567 3.1549 8.72455H3.17681Z" fill="#258BD4"/>
                        </svg>
                    </div>
                </div> -->
            </div>
            <div class="scroll-menu">
                <AsideMenuItem 
                    :text="tokens.fullScreen.dashboard" 
                    :materialIcon="'dashboard'" 
                    :active="modalFullscreen.page==='dashboard'" 
                    @click.native="changePage('dashboard')"/>
                <AsideMenuItem 
                    :text="tokens.fullScreen.personalInfo" 
                    :materialIcon="'person'" 
                    :active="modalFullscreen.page==='personal'" 
                    @click.native="changePage('personal')"/>
                <AsideMenuItem 
                    :text="tokens.fullScreen.withdrawal" 
                    :active="modalFullscreen.page==='withdrawal'" 
                    @click.native="changePage('withdrawal')">
                    <template #icon>
                        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 18 17" fill="none" class="svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M18 17V15H0L5.96046e-08 17H18Z" fill="#9A9DAB"/>
                            <path d="M7.67157 0.5L7.72461 2.49758H11.3309L4.5 9.74268L6 11.2427L12.7451 3.91179L12.7451 7.51803L14.7426 7.57107V0.5H7.67157Z" fill="#9A9DAB"/>
                        </svg>
                    </template>
                </AsideMenuItem>
                <AsideMenuItem 
                    :text="tokens.fullScreen.verification" 
                    :active="modalFullscreen.page==='verification'" 
                    @click.native="changePage('verification')">
                    <template #icon>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M13 15.45V16H5V15.45C5 14.7 5.36667 14.1042 6.1 13.6625C6.83333 13.2208 7.8 13 9 13C10.2 13 11.1667 13.2208 11.9 13.6625C12.6333 14.1042 13 14.7 13 15.45ZM10.4125 11.4125C10.0208 11.8042 9.55 12 9 12C8.45 12 7.97917 11.8042 7.5875 11.4125C7.19583 11.0208 7 10.55 7 10C7 9.45 7.19583 8.97917 7.5875 8.5875C7.97917 8.19583 8.45 8 9 8C9.55 8 10.0208 8.19583 10.4125 8.5875C10.8042 8.97917 11 9.45 11 10C11 10.55 10.8042 11.0208 10.4125 11.4125ZM2.5875 19.4125C2.97917 19.8042 3.45 20 4 20H20C20.55 20 21.0208 19.8042 21.4125 19.4125C21.8042 19.0208 22 18.55 22 18V9L20 11V18H4V6H11L13 4H4C3.45 4 2.97917 4.19583 2.5875 4.5875C2.19583 4.97917 2 5.45 2 6V18C2 18.55 2.19583 19.0208 2.5875 19.4125Z" fill="#9A9DAB"/>
                            <path d="M13 7.55L16.55 11.1L22.2 5.45L20.75 4L16.55 8.2L14.45 6.1L13 7.55Z" fill="#9A9DAB"/>
                        </svg>
                    </template>
                </AsideMenuItem>
                <AsideMenuItem 
                    :text="tokens.fullScreen.accounts" 
                    :active="modalFullscreen.page==='accounts'" 
                    @click.native="changePage('accounts')">
                    <template #icon>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.175 18.825C3.95833 19.6083 4.9 20 6 20H11.5C10.5 17.5 10.5 15 12 13.1552L4.15 11.25C4.3 10.8667 4.5375 10.5625 4.8625 10.3375C5.1875 10.1125 5.56667 10 6 10H18C18.5258 10 19.0516 10.0614 19.5559 10.1843C20.4902 10.412 21.3505 10.8505 22 11.5V8C22 6.9 21.6083 5.95833 20.825 5.175C20.0417 4.39167 19.1 4 18 4H6C4.9 4 3.95833 4.39167 3.175 5.175C2.39167 5.95833 2 6.9 2 8V16C2 17.1 2.39167 18.0417 3.175 18.825ZM18 8H6C5.63333 8 5.28333 8.04167 4.95 8.125C4.61667 8.20833 4.3 8.34167 4 8.525V8C4 7.45 4.19583 6.97917 4.5875 6.5875C4.97917 6.19583 5.45 6 6 6H18C18.55 6 19.0208 6.19583 19.4125 6.5875C19.8042 6.97917 20 7.45 20 8V8.525C19.7 8.34167 19.3833 8.20833 19.05 8.125C18.7167 8.04167 18.3667 8 18 8Z" fill="#9A9DAB"/>
                            <path d="M15.0179 19.32L13 17.04L13.75 16.2L14.4286 16.96C14.4405 16.4533 14.5327 15.96 14.7054 15.48C14.878 15 15.1369 14.5667 15.4821 14.18C15.8274 13.7933 16.2202 13.5 16.6607 13.3C17.1012 13.1 17.5476 13 18 13C18.3452 13 18.6845 13.0533 19.0179 13.16C19.3512 13.2667 19.6667 13.4333 19.9643 13.66L19.1786 14.54C18.9881 14.4333 18.7917 14.35 18.5893 14.29C18.3869 14.23 18.1845 14.2 17.9821 14.2C17.6726 14.2 17.3631 14.27 17.0536 14.41C16.744 14.55 16.4702 14.7533 16.2321 15.02C15.9821 15.3 15.7976 15.6167 15.6786 15.97C15.5595 16.3233 15.506 16.6867 15.5179 17.06L16.2857 16.2L17.0357 17.04L15.0179 19.32Z" fill="#9A9DAB"/>
                            <path d="M16.9821 20.84C16.6488 20.7333 16.3333 20.5667 16.0357 20.34L16.8214 19.46C17.0119 19.5667 17.2083 19.65 17.4107 19.71C17.6131 19.77 17.8155 19.8 18.0179 19.8C18.3274 19.8 18.6369 19.73 18.9464 19.59C19.256 19.45 19.5298 19.2467 19.7679 18.98C20.006 18.7133 20.1875 18.3933 20.3125 18.02C20.4375 17.6467 20.5 17.28 20.5 16.92L19.7143 17.8L18.9643 16.96L20.9821 14.68L23 16.96L22.25 17.8L21.5536 17.04C21.5536 17.5467 21.4702 18.0433 21.3036 18.53C21.1369 19.0167 20.881 19.4533 20.5357 19.84C20.1905 20.2267 19.7946 20.5167 19.3482 20.71C18.9018 20.9033 18.4524 21 18 21C17.6548 21 17.3155 20.9467 16.9821 20.84Z" fill="#9A9DAB"/>
                        </svg>
                    </template>
                </AsideMenuItem>
                <AsideMenuItem 
                    :materialIcon="'chat'" 
                    :text="tokens.fullScreen.liveChat" 
                    :active="modalFullscreen.page==='support'" 
                    @click.native="changePage('support')"/>
                <AsideMenuItem 
                    v-if="savingExist" 
                    :materialIcon="'savings'" 
                    :text="tokens.fullScreen.savings"
                    :active="modalFullscreen.page==='savings'" 
                    @click.native="changePage('savings')"/>
                <AsideMenuItem 
                    :materialIcon="'settings'" 
                    :text="tokens.fullScreen.settings" 
                    :active="modalFullscreen.page==='settings'" 
                    @click.native="changePage('settings')"/>

                <!-- not found in new design -->
                <!-- <li class="personal-btns" :class="{fool: brand === 'mirabud'}" v-if="personalBtns">
                    <a href="https://anydesk.com/download">
                        <img :src="staticBase + `misc/AnyDesk-logo.png`" alt="">
                        AnyDesk
                    </a>
                    <a href="https://teamviewer.com/download">
                        <img :src="staticBase + `misc/TeamViewer-logo.png`" alt="">
                        TeamViewer
                    </a>
                    <a href="https://www.aeroadmin.com" v-if="brand === 'mirabud'">
                        <img :src="staticBase + `misc/aeroadmin.png`" alt="">
                        AeroAdmin
                    </a>
                </li> -->
            </div>
        </ul>

        <!-- not found in new design -->
        <!-- <div class="side-menu hide">
            <div class="menu" :class="{hide: modals.fullscreen}">
                <div class="item" :class="{active: modalMenu.market, isMobile: isMobile}"
                     @click="showMenuModal('market')">
                    <i class="material-icons">view_list</i>
                    <span>{{ tokens.sideMenu.marketWatch.toUpperCase() }}</span>
                    <i class="material-icons toggle-btn"
                       :class="{hide: modalMenuSplit > 1 && !modalMenu.market, minus: modalMenu.market && modalMenuSplit > 0}"
                       @click.stop="toggleWidget('market')">{{ modalMenu.market ? 'remove_circle' : 'add_circle' }}</i>
                </div>
                <div class="item" :class="{active: modalMenu.orders, isMobile: isMobile}"
                     @click="showMenuModal('orders')">
                    <i class="material-icons">local_mall</i>
                    <span>{{ tokens.sideMenu.activeOrders.toUpperCase() }}</span>
                    <i class="material-icons toggle-btn"
                       :class="{hide: modalMenuSplit > 1 && !modalMenu.orders, minus: modalMenu.orders && modalMenuSplit > 0 }"
                       @click.stop="toggleWidget('orders')">{{ modalMenu.orders ? 'remove_circle' : 'add_circle' }}</i>
                </div>
                <div class="item" :class="{active: modalMenu.history, isMobile: isMobile}"
                     @click="showMenuModal('history')">
                    <i class="material-icons">history</i>
                    <span>{{ tokens.sideMenu.tradingHistory.toUpperCase() }}</span>
                    <i class="material-icons toggle-btn"
                       :class="{hide: modalMenuSplit > 1 && !modalMenu.history, minus: modalMenu.history && modalMenuSplit > 0}"
                       @click.stop="toggleWidget('history')">{{
                            modalMenu.history ? 'remove_circle' : 'add_circle'
                        }}</i>
                </div>
                <div class="item" :class="{active: modalMenu.calendar, isMobile: isMobile}"
                     @click="showMenuModal('calendar')" v-if="!removeEconomicCalendar" >
                    <i class="material-icons">today</i>
                    <span>{{ tokens.sideMenu.economicCalendar.toUpperCase() }}</span>
                    <i class="material-icons toggle-btn"
                       :class="{hide: modalMenuSplit > 1 && !modalMenu.calendar, minus: modalMenu.calendar && modalMenuSplit > 0}"
                       @click.stop="toggleWidget('calendar')">{{
                            modalMenu.calendar ? 'remove_circle' : 'add_circle'
                        }}</i>
                </div>
                <div class="item" :class="{active: modalMenu.news, isMobile: isMobile}" @click="showMenuModal('news')">
                    <i class="material-icons">campaign</i>
                    <span>{{ tokens.sideMenu.marketNews.toUpperCase() }}</span>
                    <i class="material-icons toggle-btn"
                       :class="{hide: modalMenuSplit > 1 && !modalMenu.news, minus: modalMenu.news && modalMenuSplit > 0}"
                       @click.stop="toggleWidget('news')">{{ modalMenu.news ? 'remove_circle' : 'add_circle' }}</i>
                </div>
            </div>
        </div> -->
        <AsideMenuItem 
            :materialIcon="'logout'" 
            :text="tokens.fullScreen.logOut" 
            @click.native="logout"/>
    </aside>
</template>

<script>
import {mapGetters,mapMutations} from 'vuex'
import {MODAL, MODAL_FULLSCREEN, MODAL_MENU, ACTIVE_CURRENCY} from "@/store/mutations.type"
import {isMobile} from '@/common/helpers'
import {LOGOUT} from "@/store/actions.type"
import {
    PERSONAL_BTNS,
    REST_ENDPOINT,
    BRAND,
    ASPIN_DESIGN,
    REMOVE_ECONOMIC_CALENDAR,
    HIDE_TRADING_BOT,
    HIDE_EMAIL,
    WHITE_ASPIN_THEME,
    TRADINGVIEW_THEME,
    TRADINGVIEW_BG,
    TRADINGVIEW_LINE
} from "@/common/config"
import BaseButton from '../../shared/ui/buttons/BaseButton.vue'
import AsideMenuItem from '@/new-design/not-sorted/new/AsideMenuItem.vue'
import BaseMonogram from '@/new-design/shared/ui/Icons/BaseMonogram.vue'
import {currencySign} from "@/common/helpers";

export default {
    name: "SideMenu",
    components: {BaseButton,AsideMenuItem, BaseMonogram},
    data() {
        return {
            isMobile: isMobile(),
            apiBase: REST_ENDPOINT,
            personalBtns: PERSONAL_BTNS,
            activeSelect: false,
            brand: BRAND,
            aspinDesign: ASPIN_DESIGN,
            removeEconomicCalendar: REMOVE_ECONOMIC_CALENDAR,
            hideTradingBot: HIDE_TRADING_BOT,
            hideEmail: HIDE_EMAIL,
            whiteAspinTheme: WHITE_ASPIN_THEME,
        }
    },
    methods: {
        ...mapMutations(["setLightTheme",'setThemeColors']),
        currencySign,
        switchTheme(){
            this.setLightTheme(!this.lightTheme)
            localStorage.setItem('theme',this.lightTheme ? 'white' : 'black')
            localStorage.setItem('tradingview.current_theme.name',this.lightTheme ? 'Light' : TRADINGVIEW_THEME)

            let theme = this.lightTheme ?
                {
                    ...this.themeColors,
                    'background-dark': '#fff',
                    'line': '#fff'
                } :
                {
                    ...this.themeColors,
                    'background-dark': TRADINGVIEW_BG,
                    'line': TRADINGVIEW_LINE
                }

            this.setThemeColors(theme)

            if (document.body.classList.contains('light-theme')) {
                document.body.classList.remove('light-theme');
            }

            if (this.lightTheme) {
                document.body.classList.add('light-theme');
            }
        },
        showMenuModal(item) {
            this.$store.commit(MODAL, {
                menu: true
            })

            let m = {
                orders: false,
                history: false,
                market: false,
                calendar: false,
                news: false
            }

            m[item] = true

            this.$store.commit(MODAL_MENU, m)
            this.$store.commit(MODAL, {
                hamburgerMenu: false
            })
        },
        openAutoTraderModal() {
            this.$store.commit(MODAL, {
                autoTrader: true
            })
        },
        toggleWidget(widget) {
            let n = JSON.parse(JSON.stringify(this.modalMenu))

            n[widget] = !n[widget]

            this.$store.commit(MODAL_MENU, n)

            let hideMenuModal = true

            for (let i in n) {
                if (n[i]) {
                    hideMenuModal = false
                    break
                }
            }

            if (hideMenuModal) {
                this.$store.commit(MODAL, {
                    menu: false,
                    sideMenu: !isMobile()
                })
            }

            if (n[widget] && !this.modals.menu) {
                this.$store.commit(MODAL, {
                    menu: true,
                    sideMenu: false
                })
            }

            this.$store.commit(MODAL, {
                hamburgerMenu: false
            })

        },
        closeHamburgerMenu(){
            setTimeout(() => {
                this.$store.commit(MODAL, {
                    hamburgerMenu: false
                })
            }, 0);
        },
        changePage(page) {
            this.$store.commit(MODAL, {
                fullscreen: true
            })

            this.closeHamburgerMenu()

            this.$store.commit(MODAL_FULLSCREEN, {
                page
            })
        },
        changeCurrency(currency) {
            localStorage.activeCurrency = currency
            this.$store.commit(ACTIVE_CURRENCY, currency)
        },
        logout() {
            this.closeHamburgerMenu()
            this.$store.dispatch(LOGOUT)
        },
        goTrade() {
            this.$store.commit(MODAL, {
                fullscreen: false
            })
        }
    },
    computed: {
        ...mapGetters(['tokens', 'user', 'autoTraderConfig', 'modals', 'modalMenu', 'modalFullscreen', 'user', 'accounts', 'activeAccount', 'activeCurrency', 'savingExist', 'staticBase','lightTheme','themeColors']),
        modalMenuSplit() {
            let i = 0
            for (let n in this.modalMenu) {
                if (this.modalMenu[n]) {
                    i++
                }
            }

            return i
        }
    }
}
</script>

<style scoped>

aside {
    width: 320px;
    max-width: 320px;
    background: var(--System-Surface);
    border-right: 1px solid var(--System-OutlineVariant);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    overflow-y: auto;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.3), 0px 4px 4px rgba(0, 0, 0, 0.15);
    /* padding: 0 15px; */
}

@media(max-width: 1023px) {
    aside {
        width: 280px;
        max-width: 280px;
    }

    aside.mobile {
        height: auto;
        max-height: calc(100% - 65px);
        top: 55px;
        left: 8px;
        border-radius: 8px;
        padding: 0;
        border: none;
        background: var(--System-Surface2);
    }

    aside.mobile .scroll-menu{
        height: auto;
    }
}

.top {
    padding: 24px 12px 16px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    border-bottom: 1px solid var(--System-OutlineVariant);
}

.head {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
}

.user-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 3px;
}

.name {
    color: var(--System-OnSurface);
}

.email {
    font-weight: 400;
}

.account-info {
    border-radius: 4px;
    border: 1px solid var(--System-Surface5);
    background: var(--Statelayers-onsecondaryfixedvariant-opacity16);
    display: flex;align-items: center;justify-content: space-between;
    padding: 12px;
}

.account-balance {
    color: var(--System-OnSurface);
    margin-bottom: 4px;
}

.scroll-menu {
    height: 485px;
    overflow: auto;
}

@media (max-height: 777px) {
    .scroll-menu {
        height: calc(100dvh - 290px);
        overflow: auto;
    }
}

.personal-btns.fool {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(3, max-content);
    width: 100%;
    margin-top: 15px;
}

.personal-btns.fool a {
    width: 100%;
}

.personal-btns {
    display: grid;
    grid-template-columns: repeat(2, auto);
    place-items: center;
    gap: 10px;
}

.personal-btns img {
    height: 25px;
}

.personal-btns a {
    color: var(--white);
    text-decoration: none;
    display: inline-grid;
    place-items: center;
    grid-template-columns: repeat(2, max-content);
    gap: 5px;
    font-size: 12px;
    border-radius: 5px;
    padding: 5px;
    transition: transform .3s ease-in-out;
}

.personal-btns a:hover{
    transform: scale(1.05);
}

.personal-btns a:active{
    transform: scale(.95);
}

.personal-btns a:nth-child(1) {
    border: 1px solid #ef443b;
}

.personal-btns a:nth-child(2) {
    border: 1px solid #178de5;
}

.personal-btns a:nth-child(3) {
    border: 1px solid #eb521a;
}

@media (min-width: 1000px) {
    .personal-btns {
        gap: .5vw;
    }

    .personal-btns img {
        height: 1.2vw;
    }

    .personal-btns a:nth-child(1){
        border: .1vw solid #ef443b;
    }

    .personal-btns a:nth-child(2){
        border: .1vw solid #178de5;
    }

    .personal-btns a:nth-child(3){
        border: .1vw solid #eb521a;
    }
    .personal-btns a {
        gap: .2vw;
        font-size: .7vw;
        padding: .3vw;
        border-radius: .2vw;
    }
}
</style>
